<template>
  <v-card class="pb-2">
    <v-card-title class="flex-nowrap">
      <span class="video-cim capital-first-letter-only text-truncate">{{
        modal.data.Title
      }}</span
      ><v-spacer></v-spacer>
      <v-btn icon @click="CloseModal">
        <v-icon>fas fa-times</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-card class="video-container">
        <iframe
          allowfullscreen
          :src="
            'https://www.youtube.com/embed/' + modal.data.Id + '?autoplay=1'
          "
        ></iframe>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { useModal } from '../../utils/vue/modalHandler';

export default {
  name: 'youtube-video-modal',
  data() {
    return {};
  },
  setup(props, context) {
    let { CloseModal, SetModalLoading, EmitEvent } = useModal(props, context);
    return { CloseModal, SetModalLoading, EmitEvent };
  },
  created() {},
  methods: {},
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  props: {
    modal: {
      type: Object,
      required: true,
    },
  },
};
</script>
